import { memo, useCallback } from 'react'

import { IContact } from 'clickNgo/entities/contact'
import { ModalDialog } from 'core-components/library/modalDialog'

import { ContactReassignContent } from './ContactReassignContent'

import styles from './ContactReassign.module.scss'

type Props = {
  isVisible: boolean
  reassigningWhat?: string
  availableContacts: IContact[]
  errorMessage?: string
  onClose: () => void
  onContactSelect: (contact: IContact) => void
}

export const ContactReassign = memo<Props>(
  ({
    availableContacts,
    isVisible,
    onClose,
    onContactSelect,
    reassigningWhat = 'this',
    errorMessage,
  }) => {
    const renderContent = useCallback(() => {
      return (
        <ContactReassignContent
          reassigningWhat={reassigningWhat}
          availableContacts={availableContacts}
          onClose={onClose}
          onContactSelect={onContactSelect}
          errorMessage={errorMessage}
        />
      )
    }, [availableContacts, errorMessage, onClose, onContactSelect, reassigningWhat])

    if (!isVisible) return null

    return (
      <ModalDialog
        classes={styles}
        show={isVisible}
        content={renderContent}
        onClose={onClose}
        closeOnOutsideClick={false}
        size="md"
      />
    )
  }
)

ContactReassign.displayName = 'ContactReassign'
